export default function ShouldDisplayDetailsModal(showDetailsModalState, showIgnoreModalState)
  {
    let shouldShow = showDetailsModalState;

    if(showIgnoreModalState){
      return false;
    }

    return shouldShow;
  }